<template>
    <div
        class="py-4 cursor--pointer"
        @mousedown.prevent.left="mousedown"
        @touchstart="touchstart"
    >
        <progress-bar
            ref="bar"
            :value="value"
            :min="0"
            :max="1"
            :smooth="false"
            class="position-relative cursor--pointer"
            background-color="gray"
            :ignore-readability="true"
        >
            <div
                class="rounded-circle position-absolute abs-center-y bg-light"
                :style="handlerStyle"
            />
        </progress-bar>
    </div>
</template>

<script>
import ProgressBar from "~/components/ProgressBar"
import { clamp } from "~/lib/utils"
import { useListenerManager } from "front-toolkit/plugins/ListenersPlugin"

export default {
    props: {
        value: Number,
    },

    emits: ["update:value"],

    setup() {
        const { listen } = useListenerManager()
        return { listen }
    },

    computed: {
        handlerPosition() {
            return this.value * 100
        },

        handlerStyle() {
            return {
                height: "8px",
                width: "8px",
                left: `calc(${this.handlerPosition}% - 3px)`,
            }
        },
    },

    methods: {
        mousedown(event) {
            this._removeMouseMove = this.listen("mousemove", this.mousemove)
            this._removeMouseUp = this.listen("mouseup", this.mouseup)

            const { left, width } = this.$refs.bar.$el.getBoundingClientRect()
            const offsetX = event.clientX - left
            const newValue = clamp(offsetX / width, 0, 1)
            this.$emit("update:value", newValue)
        },

        mousemove(event) {
            const { left, width } = this.$refs.bar.$el.getBoundingClientRect()
            const offsetX = event.clientX - left
            const newValue = clamp(offsetX / width, 0, 1)
            this.$emit("update:value", newValue)
        },

        mouseup() {
            this.cleanup()
        },

        touchstart(event) {
            if (event.touches.length != 1) return // We may be gesturing
            const touch = Array.from(event.targetTouches)[0]
            if (!touch) return

            this._initialTouchId = touch.identifier

            this._removeTouchMove = this.listen("touchmove", this.touchmove)
            this._removeTouchEnd = this.listen("touchend", this.touchend)

            const { left, width } = this.$refs.bar.$el.getBoundingClientRect()
            const offsetX = touch.clientX - left
            const newValue = clamp(offsetX / width, 0, 1)
            this.$emit("update:value", newValue)
        },

        touchmove(event) {
            const touch = Array.from(event.touches).find(
                t => t.identifier == this._initialTouchId
            )
            if (!touch) return

            const { left, width } = this.$refs.bar.$el.getBoundingClientRect()
            const offsetX = touch.clientX - left
            const newValue = clamp(offsetX / width, 0, 1)
            this.$emit("update:value", newValue)
        },

        touchend() {
            this.cleanup()
        },

        cleanup() {
            this._removeMouseMove && this._removeMouseMove()
            this._removeMouseUp && this._removeMouseUp()
            this._removeTouchMove && this._removeTouchMove()
            this._removeTouchEnd && this._removeTouchEnd()
        },
    },

    components: {
        ProgressBar,
    },
}
</script>
